export default "__VITE_ASSET__C8ME$mGl__"